import axiosInstance from '../config/axios';

/**
 * Subscribe to the newsletter
 * @param {{ email: string }} data
 */
export const subscribeToNewsletterApi = (data) =>
  axiosInstance.post('/newsletter/subscribe', data).then((res) => res.data);
